/**
 * Afterpay payment method - uses shared BNPL factory.
 */

import {
  type BnplCheckoutResponse,
  type BnplCustomerInfo,
  type BnplSubmitOptions,
  createBnplPaymentMethod,
} from "./bnpl-shared";

export type AfterpayCustomerInfo = BnplCustomerInfo;

export type AfterpaySubmitOptions = Omit<BnplSubmitOptions, "setupFutureUsage">;

export type AfterpayCheckoutResponse = BnplCheckoutResponse;

const AfterpayPaymentMethod = createBnplPaymentMethod({
  name: "afterpay",
  endpointPath: "afterpay",
  supportsSetupFutureUsage: false,
});

export default AfterpayPaymentMethod;
